<template>
    <v-row class="pt-sm-8 pb-0 justify-end">
        <v-col class="col-auto">
            <v-btn class="ml-3" x-small icon color="black" href="https://www.linkedin.com/in/nickylim0423/" target="_blank">
                <v-icon>fab fa-linkedin-in</v-icon>
            </v-btn>
        </v-col>
        <v-col class="col-auto">
            <v-btn class="ml-3" x-small icon color="black" href="https://dribbble.com/limyeanfen0423/" target="_blank">
                <v-icon>fab fa-dribbble</v-icon>
            </v-btn>
        </v-col>
        <v-col class="col-auto">
            <v-btn class="ml-3" x-small icon color="black" href="https://www.instagram.com/nicky_uiux/" target="_blank">
                <v-icon>fab fa-instagram</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'SocialMediaHeader'
}
</script>


// WEBPACK FOOTER //
// src/components/SocialMediaHeader.vue